<template>
  <tr :class="'border-b border-gray-300 ' + (index % 2 == 0 ? 'bg-gray-200est' : 'bg-white')">
    <td class="p-4 border-r">
      {{ opportunity.opportunity.opportunityName }}
    </td>

    <td class="p-4 border-r">
      <template v-for="(applicant, index) in opportunity.related_parties">
        <div :class="index == 0 ? '' : 'mt-1'">
          {{ applicant.fullName }}
        </div>
      </template>
    </td>

    <td class="p-4 border-r">
      {{ created }}
    </td>

    <td class="p-4 border-r">
      {{ updated }}
    </td>

    <td class="p-4 border-r">
      {{ opportunity.opportunity.transactionType }}
    </td>

    <td class="p-4 border-r">
      {{ opportunity.opportunity.status }}
    </td>

    <!--  <td class="p-4 border-r">
      
    </td>

    <td class="p-4 border-r">
      
    </td>

    <td class="p-4 border-r">
      
    </td>

    <td class="p-2 text-center">
      
    </td> -->
  </tr>
</template>

<script>

  import { EventBus } from '@/shared/event-bus';
  import moment       from 'moment'

  export default {

    props : {
      opportunity : {
        type    : Object,
        required: true
      },

      index : {
        type    : Number,
        required: true
      },
    },

    data() {
      return {
        showApplicants : false
      }
    },

    computed : {
      created() {
        return moment(this.opportunity.opportunity.createdOn).format("d MMM YYYY HH:mm")
      },

      updated() {
        return moment(this.opportunity.opportunity.lastUpdated).format("d MMM YYYY HH:mm")
      },

      // mercuryOpportunity() {
      //   // console.log(JSON.parse(this.opportunity.opportunity))
      //   return JSON.parse(this.opportunity.opportunity)
      // },

      // relatedParties() {
      //   return JSON.parse(this.opportunity.related_parties)
      // }
    },

    // methods: {

    //   clientSelected() {
    //     if (this.$store.state[this.$store.state.view + 'Module'].broker.suspended) {
    //       return;
    //     }

    //     // attach the computed values for the applicants
    //     this.client.applicants = this.applicants
    //     EventBus.$emit('open-client-actions', this.client)
    //   },

    //   showLogs() {
    //     axios.get(process.env.VUE_APP_API_URL + '/api/broker/log/list', {
    //       params : {
    //         clientId : this.client.id
    //       },

    //       headers: {
    //         'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
    //       }
    //     }).then(response => {
    //       //   this.$store.commit("setClient", response.data[0])
    //       callback(response.data)
    //     }).catch(e => {
    //       // this.errors.push(e)
    //     })
    //   },

    //   uploadToMercury(clientId) {
    //     axios.post(process.env.VUE_APP_API_URL + '/api/broker/mercury/create-opportunity', {
    //       clientId : this.client.id
    //     }, {
    //       headers: {
    //         'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
    //       }
    //     }).then(response => {
    //       //   this.$store.commit("setClient", response.data[0])
    //       callback(response.data)
    //     }).catch(e => {
    //       // this.errors.push(e)
    //     })
    //   },

    //   createMercuryContact(clientId) {
    //     axios.post(process.env.VUE_APP_API_URL + '/api/broker/mercury/create-contact', {
    //       clientId : this.client.id
    //     }, {
    //       headers: {
    //         'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
    //       }
    //     }).then(response => {
    //       // this.$store.commit("setClient", response.data[0])
    //       callback(response.data)
    //     }).catch(e => {
    //       // this.errors.push(e)
    //     })
    //   },

    //   toggleAccess(enableOrDisable) {
    //     EventBus.$emit('toggle-access', {
    //       clientId       : this.client.id, 
    //       enableOrDisable: enableOrDisable
    //     })
    //   }
    // }
  }
</script>